import { render, staticRenderFns } from "./TournamentFinderForm.vue?vue&type=template&id=64c4b966&"
import script from "./TournamentFinderForm.vue?vue&type=script&lang=js&"
export * from "./TournamentFinderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports